<template>
  <div class="floor3-wrapper">
    <div class="swiper" @mouseenter="on_bot_enter" @mouseleave="on_bot_leave">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <div class="floor3-title"><img class="floor3-title-img" src="~images/floor3/title.png" alt=""></div>
          <div class="slide-nav">
            <div class="slide-icon">
              <img class="slide-icon-img" src="~images/floor3/slide-icon1.png" alt="" @click="changeIndex(2)">
              <img class="slide-icon-img" src="~images/floor3/slide-icon2.png" alt="" @click="changeIndex(3)">
              <img class="slide-icon-img" src="~images/floor3/slide-icon3.png" alt="" @click="changeIndex(4)">
              <!--<img class="slide-icon-img" src="~images/floor3/slide-icon4.png" alt="" @click="changeIndex(5)">-->
              <img class="slide-icon-img" src="~images/floor3/slide-icon5.png" alt="" @click="changeIndex(5)">
              <!--<img class="slide-icon-img" src="~images/floor3/slide-icon6.png" alt="" @click="changeIndex(7)">-->
              <!--<img class="slide-icon-img" src="~images/floor3/slide-icon7.png" alt="" @click="changeIndex(8)">-->
            </div>
          </div>
        </swiper-slide>
        <swiper-slide><img class="big-img" src="~images/floor3/slide1.png" alt=""></swiper-slide>
        <swiper-slide><img class="big-img" src="~images/floor3/slide2.png" alt=""></swiper-slide>
        <swiper-slide><img class="big-img" src="~images/floor3/slide3.png" alt=""></swiper-slide>
        <swiper-slide><img class="big-img" src="~images/floor3/slide4.png" alt=""></swiper-slide>
        <!--<swiper-slide><img class="big-img" src="~images/floor3/slide6.png" alt=""></swiper-slide>-->
        <!--<swiper-slide><img class="big-img" src="~images/floor3/slide7.png" alt=""></swiper-slide>-->
        <!--<swiper-slide><img class="big-img" src="~images/floor3/slide8.png" alt=""></swiper-slide>-->
      </swiper>
      <div class="page-ctrl"></div>
    </div>

  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import("swiper/dist/css/swiper.css");

export default {
  data() {
    return {
      swiperOption: {
        //notNextTick: true,
        //循环
        loop: true,
        //设定初始化时slide的索引
        initialSlide: 0,
        //自动播放
        //autoplay:true,
        autoplay: {
          delay: 3000000
        },
        //滑动速度
        speed: 1000,
        //滑动方向
        direction: "horizontal",
        //滑动之后回调函数
        on: {
          slideChangeTransitionEnd: function() {
            // console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
          }
        },
        //分页器设置
        pagination: {
          el: ".page-ctrl",
          clickable: true
        }
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    mySwiper() {
      // mySwiper 是要绑定到标签中的ref属性
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    //通过获得的swiper对象来暂停自动播放
    on_bot_enter() {
      // console.log(this.mySwiper.autoplay, "this.$refs.mySwiper.autoplay");
      this.mySwiper.autoplay.stop();
    },
    on_bot_leave() {
      this.mySwiper.autoplay.start();
    },
    //点击跳到对应的index页面
    changeIndex(index){
      this.mySwiper.slideTo(index, 1000, true);//切换到第一个slide，速度为1秒
    }
  }
};
</script>

<style scoped lang="less">
.floor3-wrapper {
  width: 100%;
  height: 100%;
  background-image: url(~images/floor3/bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .swiper {
    position: absolute;
    top: 20%;
    left: 50%;
    margin-left: -42.5%;
    width: 85%;
    height: 59%;
    //background-color: red;
    //text-align: center;
    .swiper-container {
      width: 100%;
      height: 100%;
      .swiper-wrapper{
        .swiper-slide{
          width: 100%;
          .big-img{
            width: 100%;
          }
        }
      }
    }

    .floor3-title{
      .floor3-title-img{
        width: 22%;
        margin-left: 1.3%;
        margin-top: 5%;
      }
    }
    .slide-nav{
      width: 100%;
      margin-top: 10%;
      cursor: pointer;
      .slide-icon{
        .slide-icon-img{
          width: 8.5%;
          margin-right: 6%;
        }
        .slide-icon-img:last-child{
          margin-right: 0;
        }
      }
    }
  }
}
</style>
<style lang="less">
.page-ctrl {
  position: absolute;
  right: 0;
  top: 106%;
  // height: 20px;
  // background-color: #fff;
  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 43px;
    background-color: #fff!important;
  }
  .swiper-pagination-bullet:last-child{
    margin-right: 0;
  }
  .swiper-pagination-bullet-active {
      opacity: 1;
      background: #ffff40!important;
    }
    .swiper-pagination-bullet-active:after{
      content: "";
      display: block;
      box-sizing: border-box;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid #ffff40;
      position: relative;
      top: -5px;
      left: -5px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/floor/floor_3.vue